import { useAuthStore } from "@/stores/authStore";
import { PRODUCTION_HOSTNAMES } from "@/consts";
import { computed } from "vue";
import { isFlagActive } from "@/helpers/shared/flags";
import { toUnix } from "@/stories/utils/dates";

type InstitutionKeys = "BakkehusetInSilkeborg" | "MollemearskInAabenraa";

type TesterConfiguration = {
  key: InstitutionKeys;
  institutionId: string;
  startAt?: number;
  endAt?: number;
};

const TESTERS: TesterConfiguration[] = [
  {
    key: "BakkehusetInSilkeborg",
    institutionId: "10092",
    startAt: toUnix(new Date("2026-09-04T06:30:00+02:00")), // 4 September 06:30 Copenhagen
    endAt: toUnix(new Date("2026-09-22T06:30:00+02:00")), // 22 September 06:30 Copenhagen
  },
  {
    key: "MollemearskInAabenraa",
    institutionId: "10255",
    startAt: toUnix(new Date("2026-09-09T08:00:00+02:00")), // 9 September 08:00 Copenhagen
  },
];

export function usePlannerPermissions() {
  const authStore = useAuthStore();

  const isNewPlannerEnabledToTester = () => {
    if (!authStore.institutionId) {
      return false;
    }

    const tester = TESTERS.find(
      (item) => item.institutionId === authStore.institutionId,
    );

    if (!tester) {
      return false;
    }

    if (tester.startAt === undefined && tester.endAt === undefined) {
      return true;
    }

    const now = toUnix(new Date());

    return (
      (tester.startAt === undefined || now >= tester.startAt) &&
      (tester.endAt === undefined || now < tester.endAt)
    );
  };

  const view = computed(() => {
    if (
      PRODUCTION_HOSTNAMES.includes(window.location.hostname) &&
      isNewPlannerEnabledToTester()
    ) {
      return false;
    }

    return (
      authStore.currentInstitution?.settings.planner.enabledEmployees || false
    );
  });

  const viewNew = computed(() => {
    // Let's check the permissions on production
    if (PRODUCTION_HOSTNAMES.includes(window.location.hostname)) {
      return isNewPlannerEnabledToTester();
    }

    return isFlagActive("newPlanner");
  });

  return { view, viewNew };
}
